export default "__VITE_ASSET__5c74fbe3__"